function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

export var FetchResponse = /*#__PURE__*/function () {
  function FetchResponse(response) {
    _classCallCheck(this, FetchResponse);

    this.response = response;
  }

  _createClass(FetchResponse, [{
    key: "statusCode",
    get: function get() {
      return this.response.status;
    }
  }, {
    key: "redirected",
    get: function get() {
      return this.response.redirected;
    }
  }, {
    key: "ok",
    get: function get() {
      return this.response.ok;
    }
  }, {
    key: "unauthenticated",
    get: function get() {
      return this.statusCode === 401;
    }
  }, {
    key: "unprocessableEntity",
    get: function get() {
      return this.statusCode === 422;
    }
  }, {
    key: "authenticationURL",
    get: function get() {
      return this.response.headers.get('WWW-Authenticate');
    }
  }, {
    key: "contentType",
    get: function get() {
      var contentType = this.response.headers.get('Content-Type') || '';
      return contentType.replace(/;.*$/, '');
    }
  }, {
    key: "headers",
    get: function get() {
      return this.response.headers;
    }
  }, {
    key: "html",
    get: function get() {
      if (this.contentType.match(/^(application|text)\/(html|xhtml\+xml)$/)) {
        return this.text;
      }

      return Promise.reject(new Error("Expected an HTML response but got \"".concat(this.contentType, "\" instead")));
    }
  }, {
    key: "json",
    get: function get() {
      if (this.contentType.match(/^application\/.*json$/)) {
        return this.responseJson || (this.responseJson = this.response.json());
      }

      return Promise.reject(new Error("Expected a JSON response but got \"".concat(this.contentType, "\" instead")));
    }
  }, {
    key: "text",
    get: function get() {
      return this.responseText || (this.responseText = this.response.text());
    }
  }, {
    key: "isTurboStream",
    get: function get() {
      return this.contentType.match(/^text\/vnd\.turbo-stream\.html/);
    }
  }, {
    key: "isScript",
    get: function get() {
      return this.contentType.match(/\b(?:java|ecma)script\b/);
    }
  }, {
    key: "renderTurboStream",
    value: function () {
      var _renderTurboStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isTurboStream) {
                  _context.next = 13;
                  break;
                }

                if (!window.Turbo) {
                  _context.next = 10;
                  break;
                }

                _context.t0 = window.Turbo;
                _context.next = 5;
                return this.text;

              case 5:
                _context.t1 = _context.sent;
                _context.next = 8;
                return _context.t0.renderStreamMessage.call(_context.t0, _context.t1);

              case 8:
                _context.next = 11;
                break;

              case 10:
                console.warn('You must set `window.Turbo = Turbo` to automatically process Turbo Stream events with request.js');

              case 11:
                _context.next = 14;
                break;

              case 13:
                return _context.abrupt("return", Promise.reject(new Error("Expected a Turbo Stream response but got \"".concat(this.contentType, "\" instead"))));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function renderTurboStream() {
        return _renderTurboStream.apply(this, arguments);
      }

      return renderTurboStream;
    }()
  }, {
    key: "activeScript",
    value: function () {
      var _activeScript = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var script, metaTag, nonce;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isScript) {
                  _context2.next = 10;
                  break;
                }

                script = document.createElement('script');
                metaTag = document.querySelector('meta[name=csp-nonce]');

                if (metaTag) {
                  nonce = metaTag.nonce === '' ? metaTag.content : metaTag.nonce;

                  if (nonce) {
                    script.setAttribute('nonce', nonce);
                  }
                }

                _context2.next = 6;
                return this.text;

              case 6:
                script.innerHTML = _context2.sent;
                document.body.appendChild(script);
                _context2.next = 11;
                break;

              case 10:
                return _context2.abrupt("return", Promise.reject(new Error("Expected a Script response but got \"".concat(this.contentType, "\" instead"))));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function activeScript() {
        return _activeScript.apply(this, arguments);
      }

      return activeScript;
    }()
  }]);

  return FetchResponse;
}();